
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import ReportsServices from './ReportsServices';


export default function ReportSetting(param: any) {


    let [reportingList, setReportList] = useState<any>([]);
    console.log(param)
    useEffect(() => {
        reportingList = param?.reportingList
        setReportList(reportingList)
    }, [param?.reportSettings]);

    const returnValue = () => {
        param.closeReportSetting();
    }

    let [editIndex, setEditIndex] = useState(null)

    const saveReportDetails = (report: any) => {

        console.log(reportingList[report])

        ReportsServices.saveReport(reportingList[report])
        editIndex = null;
        setEditIndex(editIndex)
    }

    return (

        <Drawer open={param?.reportSettings} direction='right' className='react-drawer allowHscroll allowVscroll' size={800}>

            <div className='ws-7 pull-right box allowHscroll allowVscroll'>

                <div className="box-header bg-blue">
                    <h2 className="ws-4">Report Settings</h2>
                </div>

                <div className='ws-12 pm'>

                    <table className='newTable'>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>FilePath</th>
                                <th>Label</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                reportingList?.map((values: any, index: any) => {

                                    return (
                                        <tr>
                                            <td>{values?.name}</td>
                                            <td>{values?.rptFilePath}</td>
                                            <td>{values?.label}</td>
                                            <td>
                                                <div>
                                                    {editIndex != index && <a className="icon-btn warning btn-sm pull-left" title="Edit" onClick={() => setEditIndex(index)}>
                                                        <i className="icon-edit"></i>
                                                    </a>}

                                                    {editIndex == index && <a className="icon-btn edit btn-sm pull-left" title="Save" onClick={() => saveReportDetails(editIndex)}>
                                                        <i className="icon-save"></i>
                                                    </a>}

                                                </div>
                                                {editIndex != index && <div className='mt'> {values?.description} </div>}
                                                {editIndex == index &&
                                                    <div className='ws-10'>
                                                        <input value={values?.description} className='ws-12' onChange={(e) => {
                                                            const updatedList = [...reportingList]; updatedList[index].description = e.target.value; setReportList(updatedList);
                                                        }} />
                                                    </div>}


                                            </td>
                                        </tr>

                                    )
                                })
                            }

                        </tbody>
                    </table>

                </div>

                <div className="box-footer">
                    <button className="icon-btn delete width70 height35 pull-right" onClick={returnValue}> Close  </button>
                </div>

            </div>

        </Drawer>
    )

}